module.exports = __webpack_public_path__ + "static/img/banner2@3x.2e343d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner2@3x.png
// module id = f0cw
// module chunks = 1